import { HttpBadStatusCodeError, IErrorDetails } from '@cian/peperrors';

interface IErrorResponseSchema {
  errors?: object[] | null;
  message?: string | null;
}

interface IResponseError {
  response: IErrorResponseSchema;
  domain: string;
  defaultMessage: string;
  details?: IErrorDetails;
  statusCode?: number;
}

export const getResponseError = ({ response, domain, defaultMessage, details, statusCode = 400 }: IResponseError) => {
  return new HttpBadStatusCodeError({
    message: response.message || defaultMessage,
    domain,
    details: response.errors ? { ...details, errors: JSON.stringify(response.errors) } : undefined,
    statusCode,
  });
};
